import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutPageComponent } from './components/pages/about-page/about-page.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { BlogGridComponent } from './components/pages/blog-grid/blog-grid.component';
import { BlogRightSidebarComponent } from './components/pages/blog-right-sidebar/blog-right-sidebar.component';
import { CartPageComponent } from './components/pages/cart-page/cart-page.component';
import { CheckoutPageComponent } from './components/pages/checkout-page/checkout-page.component';
import { ComingSoonPageComponent } from './components/pages/coming-soon-page/coming-soon-page.component';
import { ContactPageComponent } from './components/pages/contact-page/contact-page.component';
import { CustomerServicePageComponent } from './components/pages/customer-service-page/customer-service-page.component';
import { FaqPageComponent } from './components/pages/faq-page/faq-page.component';
import { GalleryPageComponent } from './components/pages/gallery-page/gallery-page.component';
import { HomeDemoOneComponent } from './components/pages/home-demo-one/home-demo-one.component';
import { HomeDemoThreeComponent } from './components/pages/home-demo-three/home-demo-three.component';
import { HomeDemoTwoComponent } from './components/pages/home-demo-two/home-demo-two.component';
import { MyAccountPageComponent } from './components/pages/my-account-page/my-account-page.component';
import { NotFoundPageComponent } from './components/pages/not-found-page/not-found-page.component';
import { OrderTrackingPageComponent } from './components/pages/order-tracking-page/order-tracking-page.component';
import { RoomsPageComponent } from './components/pages/rooms-page/rooms-page.component';
import { ShopFullWidthPageOneComponent } from './components/pages/shop-full-width-page-one/shop-full-width-page-one.component';
import { ShopFullWidthPageTwoComponent } from './components/pages/shop-full-width-page-two/shop-full-width-page-two.component';
import { ShopLeftSidebarPageOneComponent } from './components/pages/shop-left-sidebar-page-one/shop-left-sidebar-page-one.component';
import { ShopLeftSidebarPageTwoComponent } from './components/pages/shop-left-sidebar-page-two/shop-left-sidebar-page-two.component';
import { ShopRightSidebarPageOneComponent } from './components/pages/shop-right-sidebar-page-one/shop-right-sidebar-page-one.component';
import { ShopRightSidebarPageTwoComponent } from './components/pages/shop-right-sidebar-page-two/shop-right-sidebar-page-two.component';
import { SimpleProductPageComponent } from './components/pages/simple-product-page/simple-product-page.component';
import { SliderProductPageComponent } from './components/pages/slider-product-page/slider-product-page.component';
import { StickyProductPageComponent } from './components/pages/sticky-product-page/sticky-product-page.component';
import { WishlistPageComponent } from './components/pages/wishlist-page/wishlist-page.component';
import { ProductpageComponent } from './components/pages/productpage/productpage.component';
import { SubcategoryComponent } from './components/pages/subcategory/subcategory.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './components/pages/terms-and-conditions/terms-and-conditions.component';
import { ReturnPolicyComponent } from './components/pages/return-policy/return-policy.component';
import { DamagePolicyComponent } from './components/pages/damage-policy/damage-policy.component';
import { ShowroomGalleryComponent } from './components/pages/showroom-gallery/showroom-gallery.component';
import { ServicesPageComponent } from './components/pages/services-page/services-page.component';
import { ProjectsPageComponent } from './components/pages/projects-page/projects-page.component';
import { ClientsPageComponent } from './components/pages/clients-page/clients-page.component';
import { CareersPageComponent } from './components/pages/careers-page/careers-page.component';
import { PopularProductsComponent } from './components/common/popular-products/popular-products.component';
import { OrderSummeryComponent } from './components/pages/order-summery/order-summery.component';
import { UserProfileComponent } from './components/pages/user-profile/user-profile.component';
import { CartSectionComponent } from './components/common/cart-section/cart-section.component';
import { CheckoutModalComponent } from './components/common/checkout-modal/checkout-modal.component';
import { ResetPasswordComponent } from './components/pages/reset-password/reset-password.component';
import { ProductDetailsComponent } from './components/pages/product-details/product-details.component';

const routes: Routes = [
    {path: '', component: HomeDemoTwoComponent},
    {path: 'home', component: HomeDemoTwoComponent},
    {path: 'index-3', component: HomeDemoThreeComponent},
    {path: 'about', component: AboutPageComponent},
    {path: 'shop-full-width-1', component: ShopFullWidthPageOneComponent},
    {path: 'shop-full-width-2', component: ShopFullWidthPageTwoComponent},
    {path: 'shop-left-sidebar-1', component: ShopLeftSidebarPageOneComponent},
    {path: 'shop-left-sidebar-2', component: ShopLeftSidebarPageTwoComponent},
    {path: 'shop-right-sidebar-1', component: ShopRightSidebarPageOneComponent},
    {path: 'shop-right-sidebar-2', component: ShopRightSidebarPageTwoComponent},
    // {path: 'simple-product', component: SimpleProductPageComponent},
    {path: 'slider-product', component: SliderProductPageComponent},
    {path: 'sticky-product', component: StickyProductPageComponent},
    {path: 'rooms', component: RoomsPageComponent},
    {path: 'customer-service', component: CustomerServicePageComponent},
    {path: 'profile-authentication', component: MyAccountPageComponent},
    {path: 'order-tracking', component: OrderTrackingPageComponent},
    {path: 'gallery', component: GalleryPageComponent},
    {path: 'cart', component: CartPageComponent},
    {path: 'checkout', component: CheckoutPageComponent},
    {path: 'wishlist', component: WishlistPageComponent},
    {path: 'blog-grid', component: BlogGridComponent},
    {path: 'blog-right-sidebar', component: BlogRightSidebarComponent},
    { path: 'blog-details/:id', component: BlogDetailsComponent },
    {path: 'faq', component: FaqPageComponent},
    {path: 'coming-soon', component: ComingSoonPageComponent},
    {path: 'contact', component: ContactPageComponent},
    {path: 'product/:id', component: SimpleProductPageComponent},
    {path: 'productpage', component: ProductpageComponent},
    { path: 'subcategory/:id', component: SubcategoryComponent },
    { path: 'popular-products', component: PopularProductsComponent },
    
    {path: 'privacy-policy', component: PrivacyPolicyComponent},
    {path: 'terms-and-conditions', component: TermsAndConditionsComponent},
    {path: 'return-policy', component: ReturnPolicyComponent},
    {path: 'damage-policy', component: DamagePolicyComponent},
	{path: 'showroom-gallery',component: ShowroomGalleryComponent},
    {path: 'services', component: ServicesPageComponent},
    {path: 'menu', component: ProjectsPageComponent},
    {path: 'clients', component: ClientsPageComponent},
    {path: 'careers', component: CareersPageComponent},
    {path: 'order-summary', component: OrderSummeryComponent},
    {path: 'user-profile', component: UserProfileComponent},
    { path: 'cart-section', component: CartSectionComponent },
    { path: 'checkout-modal', component: CheckoutModalComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'product-details/:id',component: ProductDetailsComponent}, 
    
    

    // Here add new pages component

    {path: '**', component: NotFoundPageComponent} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {
  static login: any;
}
